"use client";

import { useState, useEffect, useMemo } from "react";
import styles from "../../Supplier Ratings/css/supplierRatings.module.css";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import Button from "../../../../components/Button";
import SearchBar from "../../../../components/SearchBar";
import Dropdown from "../../../../components/Dropdown";

export default function RatingsTable({
  ratingsData,
  onEdit,
  onAddRating,
  ratingSearch,
  setRatingSearch,
  ratingSort,
  setRatingSort
}) {
  const [ratingsPage, setRatingsPage] = useState(1);
  const ratingsPageSize = 4;

  const ratingsFiltered = useMemo(() => {
    const search = String(ratingSearch || '').toLowerCase();
    let data = ratingsData.filter(r => r.supplier.toLowerCase().includes(search))
    if (ratingSort === "Overall" ) data = [...data].sort((a,b)=> (b.overall - a.overall));
    if (ratingSort === "Quality") data = [...data].sort((a,b)=> (b.quality - a.quality));
    if (ratingSort === "Reliability") data = [...data].sort((a,b)=> (b.reliability - a.reliability));
    if (ratingSort === "Delivery") data = [...data].sort((a,b)=> (b.delivery - a.delivery));
    if (ratingSort === "Cost") data = [...data].sort((a,b)=> (b.cost - a.cost));
    if (ratingSort === "Compliance") data = [...data].sort((a,b)=> (b.compliance - a.compliance));
    if (ratingSort === "Customer Service") data = [...data].sort((a,b)=> (b.customerService - a.customerService));
    return data;
  }, [ratingsData, ratingSearch, ratingSort]);

  const ratingsTotalPages = Math.max(1, Math.ceil(ratingsFiltered.length / ratingsPageSize));
  const ratingsPageData = useMemo(() => {
    const start = (ratingsPage - 1) * ratingsPageSize;
    return ratingsFiltered.slice(start, start + ratingsPageSize);
  }, [ratingsFiltered, ratingsPage]);
  useEffect(() => { setRatingsPage(1); }, [ratingSearch, ratingSort]);

  return (
    <>
      <div className={styles.headerRowCenter}>
        <h1 className={styles.ratingsTitle}>Supplier Rating</h1>
      </div>

      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: 1100,
          width: '100%',
          margin: '0 auto 0.75rem'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: '#fff',
            border: '2px solid #e6d8ff',
            borderRadius: 12,
            padding: '0.45rem 0.6rem',
            boxShadow: '0 2px 6px rgba(117,58,172,0.08)'
          }}
        >
          <span className={styles.heroLabel} style={{ marginRight: '0.25rem' }}>Filter</span>
          <div style={{ width: 180 }}>
            <Dropdown
              name="ratingSort"
              options={['Overall','Quality','Reliability','Delivery','Cost','Compliance','Customer Service' ]}
              value={ratingSort || ""}
              onChange={setRatingSort}
              placeholder=""
              className={styles.smallDropdown}
            />
          </div>
          <div style={{ width: 280 }}>
            <SearchBar value={ratingSearch || ""} onChange={setRatingSearch} placeholder="Search Supplier Name" />
          </div>
        </div>

        {/* Right add button positioned at far right */}
        <div style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
          <Button
            className={styles.addBtn}
            style={{ width: 160, height: 50 }}
            onClick={onAddRating}
          >
            + Add Rating
          </Button>
        </div>
      </div>

      <Table
        columns={[
          { header: "Supplier Name", accessor: "supplier" },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Overall Rating</div>), accessor: "overall", render: (val) => (<div style={{ textAlign: 'center', minWidth: 60 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Quality</div>), accessor: "quality", render: (val) => (<div style={{ textAlign: 'center', minWidth: 40 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Reliability</div>), accessor: "reliability", render: (val) => (<div style={{ textAlign: 'center', minWidth: 40 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Delivery</div>), accessor: "delivery", render: (val) => (<div style={{ textAlign: 'center', minWidth: 40 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Cost</div>), accessor: "cost", render: (val) => (<div style={{ textAlign: 'center', minWidth: 40 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Compliance</div>), accessor: "compliance", render: (val) => (<div style={{ textAlign: 'center', minWidth: 60 }}>{val}</div>) },
          { header: (<div style={{ textAlign: 'center', width: '100%' }}>Customer Service</div>), accessor: "customerService", render: (val) => (<div style={{ textAlign: 'center', minWidth: 60 }}>{val}</div>) },
          { header: "Action", accessor: "action", render: (_val, row, rowIndex) => (
              <Button variant="primary" className={styles.viewBtn} onClick={() => onEdit(row, rowIndex)}>
                Edit
              </Button>
            )
          }
        ]}
        data={ratingsPageData}
      />

      <div className={styles.paginationContainer}>
        <Pagination currentPage={ratingsPage} totalPages={ratingsTotalPages} onPageChange={setRatingsPage} />
      </div>
    </>
  );
}
